import { gql } from "@apollo/client";

const GET_CITIES = gql`
  query GetCities {
    cities {
      id
      name
    }
  }
`;

export default GET_CITIES;
